export default {
  heroSlide1Title: "Beschleunigung des Gesundheitswesens vom Labor zum Leben",
  // heroSlide1Subtitle: "Führende pharmazeutische Innovation mit über 40 Jahren Expertise in psychotropen APIs und komplexen Generika",
  heroSlide2Title: "Globale Reichweite – Kunden in über 80 Ländern",
  // heroSlide2Subtitle: "Aufbau starker Beziehungen zu führenden Pharma-Innovatoren und Generika-Unternehmen weltweit",
  heroSlide3Title: "Von Bausteinen zu Formulierungen: Ein Partner. Totale Zuverlässigkeit",
  // heroSlide3Subtitle: "End-to-End pharmazeutische Lösungen mit integrierter Wertschöpfungskette über KSM, APIs und FDFs",
  heroSlide4Title: "6 globale Einrichtungen | 4 F&E-Zentren | 1 globale Pharma-Plattform",
  // heroSlide4Subtitle: "Weltklasse-Fertigungs- und Forschungsinfrastruktur, die Innovation und Qualitätsexzellenz vorantreibt",
  heroSlide5Title: "Unsere Konzernunternehmen",
  // heroSlide5Subtitle: "Ein vielfältiges Portfolio von Unternehmen, die zusammenarbeiten, um umfassende pharmazeutische Lösungen zu liefern",
};

